import { useContext } from 'react';
import { IBaseAction } from '../useAction';
import { SSOLoginContext } from '../../contexts/ssoLoginContext';
import { storeSSOSessionData } from '../../utils/handleExternalSSORedirect';

export interface IWebAuthenticationAction extends IBaseAction {
  type: 'web_authentication';

  data: {
    url: string;
    ephemeralSession: boolean;
    openMode?: 'popup' | 'redirect'; // Default: 'popup'
  };
}

const useWebAuthenticationAction = () => {
  const { ssoLoginConfig } = useContext(SSOLoginContext);

  const handleWebAuthenticationAction = ({
    data: { url, openMode = 'popup' },
  }: IWebAuthenticationAction) => {
    // If openMode is 'redirect', use full-page redirect instead of popup
    if (openMode === 'redirect') {
      // Store the login HTTP call for when we return from authentication
      if (ssoLoginConfig && ssoLoginConfig.type === 'external') {
        storeSSOSessionData(ssoLoginConfig.loginHttpCall);
      }

      // Redirect to the authentication URL
      window.location.href = url;
      return;
    }

    // Otherwise, open popup
    const isCriipto =
      url &&
      (url.startsWith('https://kry.criipto.id/') ||
        url.startsWith('https://kry-test.criipto.id/'));
    const isVitality = url && url.includes(`vitality`);

    let height = 500;

    if (isVitality) {
      height = 630;
    } else if (isCriipto) {
      height = 618;
    }

    window.open(url, '', `width=375,height=${height}`);
  };

  return handleWebAuthenticationAction;
};

export default useWebAuthenticationAction;
